import { Component } from '@angular/core';
import { IAResponseModel } from '../../../../../shared/models/iauser-model';
import { Router } from '@angular/router';
import { ApiService } from '../../../../../shared/services/api.service';
import { AutofilliaService } from '../../../../../shared/services/autofillia.service';
import { API_ENDPOINTS } from '../../../../../shared/utils/const';
import IAUserModel from '../../../../../shared/models/iauser-model';
import { FormBuilder, FormGroup, FormControl, Validators, FormArray, ValidationErrors } from "@angular/forms";
import { catchError, of, interval, takeUntil } from 'rxjs';
import { ToastrService } from "ngx-toastr";
import { NgIf } from '@angular/common';
import { AbstractControl, ValidatorFn } from '@angular/forms';
import { CommonService } from '../../../../../shared/services/common.service';
import { Subject, switchMap, timer } from 'rxjs';
import { StorageService } from '../../../../../shared/services/storage.service'; // Import your service
import { CryptoService } from '../../../../../shared/services/crypto.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-iaprofile',
  templateUrl: './iaprofile.component.html',
  styleUrl: './iaprofile.component.css',
  providers: [DatePipe],
})
export class IaprofileComponent {
  maxDate: string = new Date().toISOString().split('T')[0];
  showFocusSector: boolean = false;
  isCheckedFocusSector: boolean = false;
  savedFocusSectorIds: any;
  sectorId: any;
  existingFocusSectorIds: string[] = [];
  panNotInGst: boolean = false;
  form = new FormGroup({
    registrationId: new FormControl({ value: '', disabled: true }),
    iaUserName: new FormControl({ value: '', disabled: true }),
    email: new FormControl({ value: '', disabled: true }),
    nameOfOrganisation: new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(100), Validators.pattern(this.common.nameOfOrganisation)]),
    addressOfOrganisation: new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(300), Validators.pattern(this.common.addressPattern)]),
    contactNumber: new FormControl('', [Validators.maxLength(13), Validators.pattern(this.common.phonePattern)]),
    mobileNumber: new FormControl('', [Validators.required, Validators.maxLength(10), Validators.pattern(this.common.mobilePattern)]),
    Intervention: new FormControl(''),
    InterestsId: new FormControl(''),
    focusSectorId: new FormControl(''),
    focusSectorName: new FormControl(''),

    SpocId: new FormControl(null),              // ✅ ADD THIS
    IsSpocAttached: new FormControl(false),    // ✅ ADD THIS

    SpocName: new FormControl('', [Validators.minLength(3), Validators.maxLength(50), Validators.pattern('^[a-zA-Z\\s]+$')]),
    SpocDesignation: new FormControl('', [Validators.minLength(3), Validators.maxLength(50)]),
    SpocEmail: new FormControl('', [Validators.maxLength(100), Validators.pattern(this.common.emailPattern)]),
    SpocMobile: new FormControl('', [Validators.maxLength(10), Validators.pattern(this.common.mobilePattern)]),
    spocmobotp: new FormControl('', [Validators.minLength(6), Validators.maxLength(6), Validators.pattern('^[0-9]+$')]),
  });

  form2 = new FormGroup({

    bankName: new FormControl('', [Validators.required, Validators.minLength(3), Validators.pattern('^[a-zA-Z \-\']+')]),
    accountNumber: new FormControl('', [Validators.required, Validators.minLength(9), Validators.maxLength(18), Validators.pattern('^\\d{9,18}$')]),
    ifscCode: new FormControl('', [Validators.required, Validators.minLength(3), Validators.pattern('^[A-Z]{4}0[A-Z0-9]{6}$')]),
    cin: new FormControl('', [Validators.pattern('^[LU][0-9]{5}[A-Z]{2}[0-9]{4}[A-Z]{3}[0-9]{6}$'), Validators.minLength(21)]),
    organisationPAN: new FormControl('', [Validators.required, Validators.minLength(10), Validators.pattern('^[A-Z]{5}[0-9]{4}[A-Z]{1}$')]),
    dateOfIncorporation: new FormControl(['', [Validators.required]]),
    gstNumber: new FormControl('', [Validators.required, Validators.minLength(15), Validators.pattern('^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[0-9]{1}[Z][0-9A-Z]{1}$')]),
    personName: new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(25)]),
    contactNumber: new FormControl('', [Validators.maxLength(13), Validators.pattern('^\\d{3}-\\d{4}-\\d{4}$')]),
    mobileNumber: new FormControl('', [Validators.required, Validators.pattern('^[6-9]\\d{9}$'), Validators.minLength(10),]),
    email: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$')]),
    designation: new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(25)]),
    briefBackgroundIA: new FormControl('', [Validators.required, Validators.maxLength(5000)]),
    summaryScaleIA: new FormControl('', [Validators.required, Validators.maxLength(5000)]),
    iaLogoName: new FormControl('', [
      Validators.required
    ]),
    ialogoFile: new FormControl(null),
    iaLogoPath: new FormControl(null),
    iaSigName: new FormControl('', [
      Validators.required
    ]),
    iasigFile: new FormControl(null),
    iaSigPath: new FormControl(null),
    storeFields: new FormArray([]),// Initialize as an empty array for now
    gstPercent: new FormControl('', [Validators.required, Validators.pattern('^[0-9]{1,2}$')]),
    gstType: new FormControl('', [Validators.required]),
  });
  IsProfileCompleted: boolean = false;//false
  public isSubmitted: boolean = false;
  filteredData: any;
  isButtonDisabled = false;
  focusSector: any[] = [];
  selectedFocusSector: string[] = [];
  selectedFocusSectorName: string[] = [];
  allFocusSectorIds: string[] = [];
  allFocusSectorNames: string[] = [];
  spoc: any;
  formData: any;
  name = sessionStorage.getItem('iaUserName');

  data: any[] = [];
  usr_obj!: IAUserModel;
  iaUserName = sessionStorage.getItem('iaUserName');
  RegistrationId: string = '';
  industryAssociationId = sessionStorage.getItem('industryAssociationId');
  usr_object!: IAResponseModel;

  isEditable: boolean = false;


  //Registration deatils to be viewed
  NameOfOrganisation: string = '';
  AddressOfOrganisation: string = '';
  IAUserName: string = '';
  Email: string = '';
  ContactNumber: string = '';
  MobileNumber: string = '';
  FocusSectorName: string = '';
  //FocusSectorName =[];

  //IA Organisation Information
  IndustryAssociationId: string = '';
  bankName: string = '';
  accountNumber: string = '';
  ifscCode: string = '';
  cin: string = '';
  organisationPAN: string = '';
  dateOfIncorporation: string = '';
  gstNumber: string = '';
  personName: string = '';
  contactNumber: string = '';
  mobileNumber: string = '';
  email: string = '';
  designation: string = '';
  briefBackgroundIA: string = '';
  summaryScaleIA: string = '';
  //storageService: any;
  //IsProfileCompleted: string = '';
  //maxDate: any;
  ialogoFile: File | null = null;
  iasigFile: File | null = null;
  IalogoErrors: { typeError: boolean; sizeError: boolean; dimensionError: boolean } = { typeError: false, sizeError: false, dimensionError: false };
  IasigErrors: { typeError: boolean; sizeError: boolean; dimensionError: boolean } = { typeError: false, sizeError: false, dimensionError: false };
  maxSizeInMB = 2; // Set file size limit (2 MB in this case)
  ialogoUrl: string | null = null; // Store image URL
  iasigUrl: string | null = null; // Store image URL
  originalData: any;
  gstDetails: string | null = null;
  interests: any[] = [];
  interventions: any[] = [];
  filteredInterests: any[] = [];
  selectedPairs: {
    interventionId: any;
    interventionName: string,
    interestId: string,
    interestName: string
  }[] = [];
  //spocList: any[] = []; // Array to store records
  spocList: {
    spocId?: string;
    spocName: string;
    spocDesignation: string,
    spocEmail: string,
    spocMobile: string,
    isSpocAttached?: number,
    isEdited?: boolean;
  }[] = [];
  isButtonSpocMobileDisabled: boolean = false;//commented to add harshal's functionality of keeping the send otp as diabled until obile no entered
  //isButtonSpocMobileDisabled: boolean = true;
  mobileSpocOtpTimerRunning: boolean = false;
  mobileSpocOtpTimer: number = 300;
  countdown: number = 300; // 300-second countdown for resend OTP
  countdownDisplay: string | undefined;
  isResendButtonDisabled: boolean = true;
  editingIndex: number | null = null;
  isSpocOTPVerified: boolean = false; // Initially false
  resendSpocMobileOtpDisabled: boolean = true;
  mobileOtpSent: boolean = false;
  isVerifySpocMobileOtpButtonDisabled: boolean = true;
  mobileResendCount = 1;
  maxResendAttempts: number = 5;
  isButtonMobileDisabled: boolean = false;
  countdownSubject: Subject<void> = new Subject<void>();
  otpError: boolean = false;
  otpSuccess: boolean = false;
  isOTPVerified: boolean = true;

  txtResetCancel: string = 'Reset';
  holdEditData: any;

  userType = sessionStorage.getItem('UserType');
  isMssidc: boolean = false;

  spocmobileTimer: any = null; // Store the interval reference
  selectedFocusSectorIds: {
    focusSectorName: string,
    focusSectorId: string,
  }[] = []; // To store previously selected focus sector IDs
  //focusSector: any[] = []; // To store the list of focus sectors


  constructor(private router: Router, private ia_serv: AutofilliaService, private common: CommonService, private apiService: ApiService, private toastr: ToastrService, private fb: FormBuilder, private storageService: StorageService, private cryptoService: CryptoService, private datePipe: DatePipe) {
    this.form.controls['Intervention'].setValue(null);
    this.form.controls['InterestsId'].setValue(null);
  }

  async ngOnInit() {
    if (this.userType == 'MSSIDC') {
      this.isMssidc = true;
      this.form.disable();
      this.form2.disable();
    }

    await this.LoadFocusSector();
    await this.LoadDetails();

    //// Set the maxDate as today's date
    //this.maxDate = `${yyyy}-${mm}-${dd}`;
    await this.loadInterventions();
    await this.loadInterests();

    const radioButtons = document.querySelectorAll('input[name="gstType"]');
    radioButtons.forEach(button => {
      button.addEventListener("change", () => {
        this.showTextBox();
      });
    });
  }

  GetIaOrganisationalInformation(IndustryAssociationId: any) {
    this.apiService.getRequest(API_ENDPOINTS.IA.GETIAORGANISATIONINFORMATION, { IndustryAssociationId: IndustryAssociationId }).subscribe(
      result => {
        if (result.status) {
          const decryptedData = { ...result.data };

          // Decrypt organisationPAN if available
          if (result.data?.organisationPAN) {
            try {
              decryptedData.organisationPAN = this.cryptoService.decryptIA(result.data.organisationPAN);
            } catch (error) {
              console.error("Error decrypting organisationPAN:", error);
              decryptedData.organisationPAN = ''; // Handle decryption error gracefully
            }
          }

          // Convert 'dateOfIncorporation' from 'dd-MM-yyyy' to Date object
          if (result.data?.dateOfIncorporation) {
            const [day, month, year] = result.data.dateOfIncorporation.split('-').map(Number);
            decryptedData.dateOfIncorporation = new Date(year, month - 1, day); // Convert to JavaScript Date
          } else {
            decryptedData.dateOfIncorporation = null; // Handle missing date
          }

          // Patch form values
          this.form2.patchValue(decryptedData);

          // Check if profile is completed
          this.IsProfileCompleted = !!result.data?.isProfileCompleted;

          // Set logo path
          this.ialogoUrl = result?.data?.iaLogoPathShow;

          // Set sig path
          this.iasigUrl = result?.data?.iaSigPathShow;
        }
      },
      error => {
        console.error("Error fetching organizational information:", error);
      }
    );
  }

  LoadDetails() {
    this.apiService.getRequest(API_ENDPOINTS.IA.GETUSERBYID, { IAUserName: this.iaUserName }).subscribe(

      result => {
        if (result.status) {

          this.form.patchValue(result.list1[0]);

          this.form.patchValue(result.list2[0]);
          this.form2.patchValue(result.data);



          if (result.list2 && Array.isArray(result.list2)) {
            // Initialize savedFocusSectorIds as an empty array
            this.savedFocusSectorIds = [];

            // Accumulate focusSectorIds into the array
            result.list2.forEach((sector: any) => {
            });

            // Convert sectorId values to numbers from the full list
            this.sectorId = result.list2.map((sector: any) => Number(sector.focusSectorId));

            // Now, check if each sector should be checked
            this.focusSector.forEach((sector: any) => {
              // Compare each sector's focusSectorid with the list of sectorIds
              if (this.sectorId.includes(sector.focusSectorId)) {
                sector.isChecked = true;  // Mark the sector as checked if it matches
              }
            });
          }

          this.usr_object = {
            status: result.status,
            message: result.message,
            list3: result.list3,
            list4: result.list4
          };
          //    this.selectedPairs.push(result?.list3);

          result.list3.forEach((item: { interventionId: any; interventionName: any; interestId: any; interestName: any; }) => {
            this.selectedPairs.push({
              interventionId: item.interventionId || null,
              interventionName: item.interventionName || '',
              interestId: item.interestId || '',
              interestName: item.interestName || ''
            });
          });

          result?.list4?.forEach((item: {
            spocId: string;
            spocName: string;
            spocDesignation: string;
            spocEmail: string;
            spocMobile: string;
            isSpocAttached: number;
          }) => {
            this.spocList.push({
              spocId: item.spocId || '',
              spocName: item.spocName || '',
              spocDesignation: item.spocDesignation || '',
              spocEmail: item.spocEmail || '',
              spocMobile: item.spocMobile || '',
              isSpocAttached: item.isSpocAttached || 0
            });
          });

          // Extract existing focus sectors
          this.existingFocusSectorIds = result.list2.map((sector: any) => Number(sector.focusSectorId)); // IDs from API

          this.FocusSectorName = result.list2
            .map((sector: any) => sector.focusSectorName) // Extract focusSectorName from each item in list2
            .join(', ');

          this.IndustryAssociationId = result.list1[0]['industryAssociationId'];

          this.GetIaOrganisationalInformation(this.IndustryAssociationId);

        }
      }
    );
  }

  get f() {
    return this.form2.controls;
  }
  get f1() {
    return this.form.controls;
  }
  get storeFields(): FormArray {

    return this.form2.get('storeFields') as FormArray;

  }


  formatContactNumber(event: any): void {
    let input = event.target.value.replace(/\D/g, ''); // Remove non-numeric characters

    if (input.length > 3 && input.length <= 7) {
      input = input.replace(/^(\d{3})(\d+)/, '$1-$2'); // Format as XXX-XXXX
    } else if (input.length > 7) {
      input = input.replace(/^(\d{3})(\d{4})(\d+)/, '$1-$2-$3'); // Format as XXX-XXXX-XXXX
    }

    event.target.value = input.substring(0, 13); // Limit to 13 characters (XXX-XXXX-XXXX)
  }

  numberOnly(event: any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  numberAndCapitalAlphabetsOnly(event: any): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    // Allow numbers (0-9), uppercase letters (A-Z), and lowercase letters (a-z)
    if (
      (charCode >= 48 && charCode <= 57) || // Numbers
      (charCode >= 65 && charCode <= 90) || // Uppercase letters
      (charCode >= 97 && charCode <= 122) // Lowercase letters
    ) {
      // If the input is a lowercase letter, convert it to uppercase
      if (charCode >= 97 && charCode <= 122) {
        event.target.value += String.fromCharCode(charCode).toUpperCase();
        event.preventDefault(); // Prevent adding the original lowercase letter
      }
      return true;
    }

    // Block all other characters

    return false;

  }

  onInputPan(event: any): void {
    let input = event.target.value.toUpperCase();
    let formattedInput = '';

    for (let i = 0; i < input.length; i++) {
      if (i < 5 && /[A-Z]/.test(input[i])) {
        formattedInput += input[i];
      } else if (i >= 5 && i < 9 && /\d/.test(input[i])) {
        formattedInput += input[i];
      } else if (i === 9 && /[A-Z]/.test(input[i])) {
        formattedInput += input[i];
      } else {
        break;
      }
    }
    event.target.value = formattedInput;
    this.form2.get('organisationPAN')?.setValue(formattedInput, { emitEvent: false });

    this.panInGstValidator();


  }

  numberanddashOnly(event: any): boolean {
    const charCode = event.which ? event.which : event.keyCode;

    if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 45) {
      return false;
    }
    return true;
  }
  textOnly(event: any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 65 || charCode > 90) && (charCode < 97 || charCode > 122)) {
      return false;
    }
    return true;
  }

  textAndSpaceOnly(event: any): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    const target = event.target as HTMLInputElement;
    const currentValue = target.value;

    // Allow letters (A-Z, a-z) and a single space (not after another space)
    if ((charCode >= 65 && charCode <= 90) || // Uppercase letters
      (charCode >= 97 && charCode <= 122) || // Lowercase letters
      (charCode === 32 && !currentValue.endsWith(' '))) { // Space and not after another space
      return true;
    }

    // Block all other characters
    return false;
  }

  textAndSpaceAndDotOnly(event: any): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    const char = String.fromCharCode(charCode);
    const target = event.target as HTMLInputElement; // Get the input element
    const currentValue = target.value;

    // Allow letters (A-Z, a-z), single space, and dot (.)
    if ((charCode >= 65 && charCode <= 90) || // Uppercase letters
      (charCode >= 97 && charCode <= 122) || // Lowercase letters
      charCode === 46 || // Dot
      (charCode === 32 && !currentValue.endsWith(' '))) { // Single space and not after another space
      return true;
    }

    // Block all other characters
    return false;
  }


  textSpaceCommaOnly(event: any): boolean {
    const charCode = event.which ? event.which : event.keyCode;

    // Allow letters (A-Z, a-z), space (ASCII 32), comma (ASCII 44), full stop (ASCII 46), and hyphen (ASCII 45)
    if (
      (charCode >= 65 && charCode <= 90) || // Uppercase letters
      (charCode >= 97 && charCode <= 122) || // Lowercase letters
      charCode === 32 || // Space
      charCode === 44 || // Comma
      charCode === 46 || // Full stop
      charCode === 45 // Hyphen
    ) {
      return true;
    }

    // Block all other characters
    return false;
  }


  onIALogoFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;

    if (input.files && input.files.length) {
      this.ialogoFile = input.files[0];

      // Reset file errors
      this.IalogoErrors = { typeError: false, sizeError: false, dimensionError: false };

      // Check file type (only images like jpg, png)
      const validTypes = ['image/jpeg', 'image/png', 'image/jpg'];
      if (!validTypes.includes(this.ialogoFile.type)) {
        this.IalogoErrors.typeError = true;
      }

      // Check file size (maxSizeInMB limit)
      const maxSizeInBytes = this.maxSizeInMB * 1024 * 1024; // Convert MB to Bytes
      if (this.ialogoFile.size > maxSizeInBytes) {
        this.IalogoErrors.sizeError = true;
      }

      // Check image dimensions (should be 200x200)
      const file = this.ialogoFile;
      if (file) {
        const reader = new FileReader();
        reader.onload = (e: any) => {
          const img = new Image();
          img.onload = () => {
            if (img.width > 200 || img.height > 200) {
              this.IalogoErrors.dimensionError = true;
              this.form2.patchValue({
                iaLogoName: null
              });
              this.ialogoUrl = null; // Clear preview if dimensions are wrong
            }
            else {

              this.form2.get('ialogoFile')?.markAsTouched();
              this.form2.get('ialogoFile')?.markAsDirty();
            }
          };
          img.src = e.target.result;
        };
        reader.readAsDataURL(file);
      }

      // Set file name in form if validation passes
      if (!this.IalogoErrors.typeError && !this.IalogoErrors.sizeError) {
        this.form2.patchValue({
          iaLogoName: this.ialogoFile.name
        });
        this.form2.get('ialogoFile')?.markAsTouched();
        this.form2.get('ialogoFile')?.markAsDirty();

        const file = this.ialogoFile;
        if (file) {
          const reader = new FileReader();
          reader.onload = (e: any) => {
            this.ialogoUrl = e.target.result; // Show selected file as a preview
          };
          reader.readAsDataURL(file);
        }


      } else {
        this.form2.patchValue({
          iaLogoName: null
        });
      }
    }

  }

  onIASigFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;

    if (input.files && input.files.length) {
      this.iasigFile = input.files[0];

      // Reset file errors
      this.IasigErrors = { typeError: false, sizeError: false, dimensionError: false };

      // Check file type (only images like jpg, png)
      const validTypes = ['image/jpeg', 'image/png', 'image/jpg'];
      if (!validTypes.includes(this.iasigFile.type)) {
        this.IasigErrors.typeError = true;
      }

      // Check file size (maxSizeInMB limit)
      const maxSizeInBytes = this.maxSizeInMB * 1024 * 1024; // Convert MB to Bytes
      if (this.iasigFile.size > maxSizeInBytes) {
        this.IasigErrors.sizeError = true;
      }

      // Check image dimensions (should be 200x200)
      const file = this.iasigFile;
      if (file) {
        const reader = new FileReader();
        reader.onload = (e: any) => {
          const img = new Image();
          img.onload = () => {
            if (img.width > 200 || img.height > 200) {
              this.IasigErrors.dimensionError = true;
              this.form2.patchValue({
                iaSigName: null
              });
              this.iasigUrl = null; // Clear preview if dimensions are wrong
            }
            else {

              this.form2.get('iasigFile')?.markAsTouched();
              this.form2.get('iasigFile')?.markAsDirty();
            }
          };
          img.src = e.target.result;
        };
        reader.readAsDataURL(file);
      }

      // Set file name in form if validation passes
      if (!this.IasigErrors.typeError && !this.IasigErrors.sizeError) {
        this.form2.patchValue({
          iaSigName: this.iasigFile.name
        });
        this.form2.get('iasigFile')?.markAsTouched();
        this.form2.get('iasigFile')?.markAsDirty();

        const file = this.iasigFile;
        if (file) {
          const reader = new FileReader();
          reader.onload = (e: any) => {
            this.iasigUrl = e.target.result; // Show selected file as a preview
          };
          reader.readAsDataURL(file);
        }


      } else {
        this.form2.patchValue({
          iaSigName: null
        });
      }
    }

  }


  onSaveClick(form: any) { }

  navigatetopage() {
    sessionStorage.setItem('readonlyUsername', JSON.stringify(this.iaUserName));
    sessionStorage.setItem('singInAs', 'IAUserName');
    this.router.navigateByUrl("/changepassword");

  }

  Logout() {
    sessionStorage.clear();
    this.router.navigateByUrl("/login");
  }

  onReset() {
    this.form2.reset();
    sessionStorage.clear();
  }

  prepareFormData(): FormData {
    const formData = new FormData();

    Object.keys(this.form2.value).forEach(key => {
      let value = this.form2.get(key)?.value;

      //// Format dateOfIncorporation before appending
      //if (key === 'dateOfIncorporation' && value) {
      //  value = this.datePipe.transform(value, 'dd/MM/yyyy'); // Format date
      //}

      // Format dateOfIncorporation before appending
      if (key === 'dateOfIncorporation' && value) {
        value = this.datePipe.transform(value, 'yyyy-MM-dd'); // Format date to YYYY-MM-DD
      }

      if (value !== null) {
        formData.append(key, value);
      }
    });

    // Append the file separately
    if (this.ialogoFile) {
      formData.append('ialogoFile', this.ialogoFile);  // Add the actual file
    }

    // Append the file separately
    if (this.iasigFile) {
      formData.append('iasigFile', this.iasigFile);  // Add the actual file
    }

    formData.append('industryAssociationId', this.IndustryAssociationId);

    return formData;
  }

  onSubmit() {
    this.isSubmitted = true;
    this.isEditable = false;
    //this.form2.get('bankName')?.disable();

    if (this.form2.valid && !this.IalogoErrors.typeError && !this.IalogoErrors.sizeError) {

      const formDatas = this.prepareFormData();

      // Encrypt the organisationPAN before sending
      const organisationPAN = this.form2.get('organisationPAN')?.value;
      if (organisationPAN) {
        const encryptedPAN = this.cryptoService.encryptIA(organisationPAN); // Encrypt using CryptoService
        //console.log("Encrypted PAN:", encryptedPAN);

        // Replace plaintext with encrypted value in FormData
        formDatas.set('organisationPAN', encryptedPAN);
      }


      this.apiService.postRequest(API_ENDPOINTS.IA.IAORGANISATIONINFORMATION, formDatas).subscribe(res => {

        if (res.status) {
          this.toastr.success(res.message);
          this.router.navigateByUrl("/iaproposalpage");
        }
        //this.toastr.success(
        //  "You have completed the profile, you can now create a proposal",
        //  "Profile Completed"
        //);
        //this.router.navigateByUrl("/createnewproposal");
        this.router.navigateByUrl("/iaproposalpage");
      });
    }
    catchError(error => {
      let errorMessage = "An error occurred during login.";
      if (error.status === 409) {
        errorMessage = "User already exists";
      } else if (error.status === 400) {
        errorMessage = "Bad Request";
      }
      alert(errorMessage);
      return of(null);
    });
    this.form2.markAllAsTouched();
  }

  // Function to enable form editing
  enableEdit() {
    this.isEditable = true;
    this.form2.get('bankName')?.enable();
    this.form2.get('email')?.enable();
  }

  updateEdit() {
    //this.isSubmitted = true;
    this.isEditable = true;

    if (this.form2.invalid) {
      this.form2.markAllAsTouched();
      this.form2.updateValueAndValidity({ onlySelf: false, emitEvent: true });
      return false;
    }



    if (this.form2.valid && !this.IalogoErrors.typeError && !this.IalogoErrors.sizeError && !this.IasigErrors.typeError && !this.IasigErrors.sizeError) {

      const formDatas = this.prepareFormData();
      //Added by swapnali

      const organisationPAN = this.form2.get('organisationPAN')?.value;
      if (organisationPAN) {
        const encryptedPAN = this.cryptoService.encryptIA(organisationPAN); // Encrypt using CryptoService
        // Replace plaintext with encrypted value in FormData
        formDatas.set('organisationPAN', encryptedPAN);
      }
      //--END--

      this.apiService.postRequest(API_ENDPOINTS.IA.UPDATEIAORGANISATIONINFORMATION, formDatas).subscribe(res => {
        if (res.status) {
          this.toastr.success(res.message);
          this.router.navigateByUrl("/iaproposalpage");
        }

        //this.toastr.warning(res.message);
        // alert(res.message);
        //alert("You have updated the profile,you can now create proposal");

      });
    }
    this.form2.markAllAsTouched();
    //this.form2.markAllAsTouched();
    // Mark all fields as touched to trigger validation messages
    //this.form2.markAllAsTouched();

    // Force validation update
    //this.form2.updateValueAndValidity();
    return;



  }

  async loadInterventions(): Promise<void> {
    try {
      const data = await this.apiService.getRequest(API_ENDPOINTS.MASTERS.INTERVENTION.GETLIST).toPromise();
      if (data.data && Array.isArray(data.data)) {
        this.interventions = data.data;
      } else {
        console.error('Unexpected data structure:', data);
      }
    } catch (error) {
      console.error('Error fetching interventions:', error);
    }
  };
  async loadInterests(): Promise<void> {
    try {
      const data = await this.apiService.getRequest(API_ENDPOINTS.MASTERS.INTEREST.GETLIST).toPromise();
      if (data.data && Array.isArray(data.data)) {
        this.interests = data.data;
      } else {
        console.error('Unexpected data structure:', data);
      }
    } catch (error) {
      console.error('Error fetching interests:', error); // Handle error
    }
  };

  onInterventionChange(event: any): void {
    const interventionId = event.interventionId;
    this.filteredInterests = this.interests.filter(interest =>
      interest.interventionId == interventionId
    );
  }

  addPair(): void {
    const interventionId = this.form.get('Intervention')?.value;
    const interestId = this.form.get('InterestsId')?.value;

    // Check if both fields are selected
    if (!interventionId) {
      alert('Please select an intervention.');
      return;
    }

    if (!interestId) {
      alert('Please select an interest.');
      return;
    }

    if (interventionId && interestId) {
      const selectedIntervention = this.interventions.find(type => type.interventionId == interventionId);
      const selectedInterest = this.interests.find(type => type.interestId == interestId);

      if (selectedIntervention && selectedInterest) {
        // Check for duplicates
        const duplicate = this.selectedPairs.some(pair =>
          pair.interventionId === selectedIntervention.interventionId &&
          pair.interestId === selectedInterest.interestId
        );

        if (!duplicate) {
          this.selectedPairs.push({
            interventionId: selectedIntervention.interventionId,
            interventionName: selectedIntervention.interventionName,
            interestId: selectedInterest.interestId,
            interestName: selectedInterest.interestName,
          });
          this.resetSelection();
        } else {
          alert('This intervention and interest pair already exists.');
        }
      }
    }
  }

  resetSpocSelection(): void {

    if (this.txtResetCancel === 'Cancel') {

      if (this.originalData) {

        // Add the record back to the table at the same position
        this.spocList.splice(this.editingIndex!, 0, this.originalData);

      }

      // Clear edit state
      this.editingIndex = null;
      this.originalData = null;
      this.holdEditData = null;

      this.txtResetCancel = 'Reset';

      // Reset form
      this.form.reset();
    }
  }

  resetSelection(): void {
    this.form.get('Intervention')?.setValue('');
    this.form.get('InterestsId')?.setValue('');
    this.filteredInterests = [];
  }
  removePair(index: number): void {
    this.selectedPairs.splice(index, 1);
  }

  isSpocLocked(spoc: any): boolean {
    return spoc?.isSpocAttached === 1;
  }

  removeSpoc(index: number): void {
    const spoc = this.spocList[index];

    if (spoc?.isSpocAttached == 1) {
      this.toastr.warning("You cannot remove this SPOC because it has an active event linked.");
      return;
    }

    if (confirm("Are you sure you want to remove this SPOC?")) {
      this.spocList.splice(index, 1);
    }
  }

  editSpoc(index: number): void {

    const spoc = this.spocList[index];

    if (spoc.isSpocAttached === 1) {
      this.toastr.warning("You cannot edit this SPOC because it has an active event linked.");
      return;
    }

    this.txtResetCancel = 'Cancel';
    this.isButtonSpocMobileDisabled = false;
    this.mobileSpocOtpTimerRunning = false;
    this.mobileSpocOtpTimer = 300;

    this.editingIndex = index;

    this.holdEditData = { ...spoc };
    this.originalData = { ...spoc };

    this.form.patchValue({
      //SpocId: spoc.spocId,
      SpocName: spoc.spocName,
      SpocDesignation: spoc.spocDesignation,
      SpocEmail: spoc.spocEmail,
      SpocMobile: spoc.spocMobile,
      //IsSpocAttached: spoc.isSpocAttached
    });

    spoc.isEdited = true;
    this.form.get('spocmobotp')?.reset();
    this.spocList.splice(index, 1);
  } 


  add(): void {
    if (
      this.form.controls.SpocName.value &&
      this.form.controls.SpocDesignation.value &&
      this.form.controls.SpocEmail.value &&
      this.form.controls.SpocMobile.value &&
      this.isSpocOTPVerified
    ) {
      const newData = {
        spocId: this.form.controls.SpocId.value ?? '',
        spocName: this.form.controls.SpocName.value ?? '',
        spocDesignation: this.form.controls.SpocDesignation.value ?? '',
        spocEmail: this.form.controls.SpocEmail.value ?? '',
        spocMobile: this.form.controls.SpocMobile.value ?? '',
        isSpocAttached: this.form.controls.IsSpocAttached.value ? 1 : 0
      };

      if (this.editingIndex !== null) {
        // Check if data has changed
        if (JSON.stringify(this.originalData) !== JSON.stringify(newData)) {
          // Update existing record
          this.spocList.splice(this.editingIndex, 1, newData);
        } else {
          // Re-add the original record without change
          this.spocList.splice(this.editingIndex, 1, this.originalData);
        }
        this.editingIndex = null;
      } else {
        // Add new record normally
        this.spocList.push(newData);
      }

      //  Reset form fields after updating
      this.resetSpocSelection();

      this.isButtonSpocMobileDisabled = false;
      this.mobileSpocOtpTimerRunning = false;
      this.form.controls['spocmobotp'].enable();
    } else {
      this.toastr.error("Fill in the Spoc details and verify the OTP to add.");
    }

    this.isSpocOTPVerified = false;
    this.form.get('spocmobotp')?.reset();
    this.form.controls.spocmobotp.markAllAsTouched();
  }

  startSpocMobileOtpTimer() {
    this.mobileSpocOtpTimerRunning = true;
    this.mobileSpocOtpTimer = 300;
    this.resendSpocMobileOtpDisabled = true;  // Disable resend while timer is running

    const spocmobileTimer = setInterval(() => {
      if (this.mobileSpocOtpTimer > 0) {
        this.mobileSpocOtpTimer--;
      } else {
        this.stopSpocMobCountdown();
      }
    }, 1000);
  }

  stopSpocMobCountdown() {

    clearInterval(this.spocmobileTimer);
    this.spocmobileTimer = null;
    this.mobileSpocOtpTimerRunning = false;
    this.resendSpocMobileOtpDisabled = false;
  }

  SendSpocOTP() {
    this.form.controls['SpocMobile'].markAsTouched();
    if (this.form.controls.SpocMobile.invalid) {
      //alert('Please enter a valid mobile number.');
      return;
    }
    //this.isButtonDisabled = true;
    //this.isButtonMobileDisabled = true; // Disable "Send Mobile OTP" button
    this.isButtonSpocMobileDisabled = true; // Disable the Mobile Resend OTP button


    this.isSpocOTPVerified = false;
    this.form.controls['spocmobotp'].enable(); // Ensure FormControl is enabled
    const otpdata =
    {
      otpType: 'mobile',
      otpValue: this.form.controls.SpocMobile.value
    }
    this.apiService.postRequest(API_ENDPOINTS.Otp.SendOtp, otpdata).subscribe(
      res => {
        if (res.status) {
          this.toastr.success(res.message);
          this.mobileOtpSent = true;
          this.isVerifySpocMobileOtpButtonDisabled = false;  // Enable Verify button after OTP sent
          this.startSpocMobileOtpTimer();
        }
        else {
          alert('Entered Mobile OTP is incorrect. Please enter correct OTP');
          //this.isButtonDisabled = false;
          this.isButtonSpocMobileDisabled = false; // Re-enable if there's an error
        }
      });
  }

  ReSendSpocMobileOTP() {
    if (!this.form.controls.SpocMobile.valid) {
      //alert('Please enter a valid mobile number.');
      return;
    }

    if (this.mobileResendCount >= this.maxResendAttempts) {
      this.toastr.warning('You have reached the maximum resend attempts for mobile OTP today.', 'Warning');
      //alert('You have reached the maximum resend attempts for mobile OTP today.');
      return;
    }

    this.mobileResendCount++;
    this.isButtonMobileDisabled = true; // Disable resend button until request complet
    //this.isButtonDisabled = true;

    const otpdata = {
      otpType: 'mobile',
      otpValue: this.form.controls.SpocMobile.value
    };

    this.apiService.postRequest(API_ENDPOINTS.Otp.SendOtp, otpdata).subscribe(res => {
      if (res.status) {
        this.resetCountdown(); // Restart the countdown for mobile OTP
        this.startSpocMobileOtpTimer(); // Start the mobile OTP timer after resend
        //this.isButtonDisabled = false;
      } else {
        alert('Error... Please try after sometime!!');
        this.isButtonMobileDisabled = false; // Re-enable if there's an error
      }
    });
  }
  verifySpocMobileOtp() {
    const otpdata = {
      OtpType: 'mobile',
      OtpValue: this.form.controls.SpocMobile.value,
      Otp: this.form.controls.spocmobotp.value?.toString()
    };

    this.apiService.postRequest(API_ENDPOINTS.Otp.VerifyOtp, otpdata).subscribe(
      (res) => {
        /*if (res.status)*/
        if (res.message === "OTP verified successfully.") {
          this.toastr.success(res.message);
          this.otpError = false;
          this.otpSuccess = true;
          this.stopCountdown();
          this.stopSpocMobCountdown();
          /*this.mobileSpocOtpTimer = 300;//if verified even after 5 minthe resend otp button will be disabled*/
          // Mark the OTP field as readonly
          this.isOTPVerified = true;
          this.form.controls.spocmobotp.disable(); // Disable the field to make it readonly
          //this.isResendButtonDisabled = true; //if verified even after 1 minute resend otp button will be disabled */
          this.isSpocOTPVerified = true; //for spoc
          this.isVerifySpocMobileOtpButtonDisabled = true;
        } else {
          this.otpError = true;
          this.otpSuccess = false;
        }
      },
      (error) => {
        //  console.error('Error during mobile OTP verification:', error);
        // this.toastr.error("Entered Mobile OTP is incorrect. Please enter correct OTP");
        this.otpError = true;
        this.otpSuccess = false;
      }
    );
  }

  resetCountdown() {
    this.stopCountdown();
    this.startResendCountdown();
  }
  stopCountdown() {
    this.countdownSubject.next();
    this.isResendButtonDisabled = false;
    this.countdownDisplay = '';
  }
  startResendCountdown() {
    this.isResendButtonDisabled = true;
    this.countdown = 300; // 300-second countdown
    interval(1000).pipe(takeUntil(this.countdownSubject)).subscribe(() => {
      if (this.countdown > 0) {
        this.countdown--;
        this.updateCountdownDisplay();
      } else {
        this.stopCountdown();
      }
    });
  }
  updateCountdownDisplay() {
    const minutes = Math.floor(this.countdown / 60);
    const seconds = this.countdown % 60;
    this.countdownDisplay = `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
  }



  textandspecialcharsOnly(event: any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 65 || charCode > 90) && (charCode < 97 || charCode > 122) && (charCode < 32 || charCode > 47)) {
      return false;
    }
    return true;
  }

  combinedList() {
    // Tagging each source with a "source" property to differentiate them
    const selectedPairsWithSource = this.selectedPairs?.map(pair => ({
      ...pair,
      source: 'selectedPairs'
    })) || [];

    const usrList3WithSource = this.usr_object?.list3?.map(interest => ({
      ...interest,
      source: 'usr_list3'
    })) || [];

    // Concatenate both arrays
    return [...selectedPairsWithSource, ...usrList3WithSource];
  }

  prepareFormDataIA(): FormData {
    const formData = new FormData();

    Object.keys(this.form.value).forEach(key => {
      const value = this.form.get(key)?.value;
      if (value !== null) {
        formData.append(key, value);
      }

    });
    //const IndustryAssociationId = sessionStorage.getItem('iauserid');

    //formData.append('RegistrationId', this.form.controls.registrationId);
    return formData;
  }

  EditIA() {

    this.isEditable = true;
    if (this.form.controls.addressOfOrganisation.valid && this.form.controls.nameOfOrganisation.valid && this.form.controls.contactNumber.valid && this.form.controls.mobileNumber.valid && this.spocList.length >= 1 && this.selectedPairs.length >= 1) {
      // Get existing focus sector IDs from list2
      const existingFocusSectorIds = this.existingFocusSectorIds || [];

      // Merge existing and new focus sector IDs
      const newFocusSectorIds = this.selectedFocusSector || []; // New IDs selected by the user
      this.allFocusSectorIds = [...new Set([...existingFocusSectorIds, ...newFocusSectorIds])]; // Proper merging and deduplication

      // Set the merged values in the form
      this.form.controls.focusSectorId.setValue(this.allFocusSectorIds.join(','));
      //this.form.controls.focusSectorName.setValue(this.allFocusSectorNames.join(','));

      const formdatavalue = {
        ...this.formData,
        ...this.getFormValuesIncludingDisabled(),
        iaUserInterests: this.selectedPairs,
        iaRegistrationSpocDetails: this.spocList,

        focusSectorId: this.form.controls.focusSectorId.value, // Merged IDs
      };

      this.apiService.postRequest(API_ENDPOINTS.IA.UPDATEIAUSERPROFILE, formdatavalue).subscribe(res => {
        /*alert(res.message);*/
        if (res.status) {
          this.toastr.success(res.message);
          this.router.navigateByUrl("/iaproposalpage");

        }

      });

    }
    catchError(error => {
      let errorMessage = "An error occurred during login.";
      if (error.status === 409) {
        errorMessage = "User already exists";
      } else if (error.status === 400) {
        errorMessage = "Bad Request";
      }
      alert(errorMessage);
      return of(null);
    });

  }
  getFormValuesIncludingDisabled() {
    const formValues = this.form.getRawValue();
    return formValues;
  }

  async LoadFocusSector() {
    try {
      const data = await this.apiService.getRequest(API_ENDPOINTS.FOCUSSECTOR.GETFOCUSSECTOR).toPromise();
      if (Array.isArray(data)) {
        this.focusSector = data;
      } else if (data.data && Array.isArray(data.data)) {
        this.focusSector = data.data;
      } else {
        console.error('Unexpected data structure:', data);
      }
    } catch (error) {
      console.error('Error fetching focus sectors:', error); // Handle error
    }
  };
  onFocusSectorChange(event: Event, focusSectorId: string, focusSectorName: string) {
    const inputElement = event.target as HTMLInputElement;
    const isChecked = inputElement.checked;
    this.selectedFocusSector = this.existingFocusSectorIds;

    if (isChecked) {
      if (!this.selectedFocusSector.includes(focusSectorId)) {
        this.selectedFocusSector.push(focusSectorId);
        this.selectedFocusSectorName.push(focusSectorName);
      }
    } else {
      const index = this.selectedFocusSector.indexOf(focusSectorId);
      if (index > -1) {
        this.selectedFocusSector.splice(index, 1);
        this.selectedFocusSectorName.splice(index, 1);
      }
    }
  }
  panInGstValidator() {

    const organisationPAN = this.form2.get('organisationPAN')?.value;
    const gstNumber = this.form2.get('gstNumber')?.value;

    if (organisationPAN && gstNumber) {
      // If the PAN is not part of the GST Number, show the error
      if (!gstNumber.includes(organisationPAN)) {
        this.panNotInGst = true;
      } else {
        // If PAN is present in GST, reset the error flag
        this.panNotInGst = false;
      }
    } else {
      // Reset the error flag if fields are empty
      this.panNotInGst = false;
    }
  }

  showTextBox() {
    const textBox = document.getElementById("gstPercent") as HTMLInputElement;
    const label = document.getElementById("gstLabel");

    if (textBox && label) {
      textBox.style.display = "block";
      label.style.display = "block";

      // Corrected: Explicitly access 'value' property
      textBox.value = "";

      // Reset the Angular form control properly
      const formControl = this.form2.get('gstPercent');
      if (formControl) {
        formControl.setValue(null); // Explicitly setting it to null
        formControl.markAsTouched();
        formControl.markAsDirty();
        formControl.updateValueAndValidity(); // Ensures validation updates properly
      }
    }


  }

  blankTextBox() {
    const textBox = document.getElementById("gstPercent") as HTMLInputElement;

    if (textBox) {
      textBox.value = ""; // Clears the textbox content

      // Reset the Angular form control properly
      const formControl = this.form2.get('gstPercent');
      if (formControl) {
        formControl.setValue(null); // Explicitly setting it to null
        formControl.markAsTouched();
        formControl.markAsDirty();
        formControl.updateValueAndValidity(); // Ensures validation updates properly
      }
    }
  }

  gstnumberOnly(event: any): boolean {

    const inputElement = event.target as HTMLInputElement;

    // Check if the length is already 2 characters, then prevent additional input
    if (inputElement.value.length > 2) {
      event.preventDefault(); // Stops further keypresses
      return false;
    }

    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

}
